var React = require('react');
var moment = require('moment');
var _ = require('lodash');
var cx = require('classnames');
import Week from './Week.jsx';

export default class Month extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    getWeekRows() {
        // Calculate the minimun days to display
        // If month has 31 days and first day is on Tuesday,
        // Then we display in the calender at least 31 + (Mon + Sun last month)= 33 days
        // Weekday instead of day as it is locale aware
        var dayOfWeek = this.props.firstDay.weekday(),
            month = this.props.firstDay.month();
        var firstDayTable = moment.utc(this.props.firstDay).subtract(dayOfWeek, 'days');
        var rows = [];
        // We always display 6 weeks so we have a nice grid with the same height
        _.times(6, function(n) {
            var firstDayOfWeek = moment.utc(firstDayTable).add(n * 7, 'days');

            rows.push(
                <Week 
                    key={n} 
                    firstDayOfWeek={firstDayOfWeek} 
                    month={this.props.firstDay}
                    interactive={this.props.interactive}
                    refresh={this.props.refresh}
                    selector={this.props.selector}
                    static={this.props.static} 
                />
            );
        }.bind(this))
        return (
            <tbody key={'tbodym'+month}>
                {rows}
            </tbody>
        );
    }


    render() {
        var month = this.props.firstDay.month(),
            monthClass = 'col-md-6';
        return (
            <table className="month" key={'m'+month}>
                <thead key={'thm'+month}>
                    <tr key={'trm'+month}>
                        <th className="day-header" key={'trm'+month+''+moment().day(1).format('dd')}>{moment().day(1).format('dd')}</th>
                        <th className="day-header" key={'trm'+month+''+moment().day(2).format('dd')}>{moment().day(2).format('dd')}</th>
                        <th className="day-header" key={'trm'+month+''+moment().day(3).format('dd')}>{moment().day(3).format('dd')}</th>
                        <th className="day-header" key={'trm'+month+''+moment().day(4).format('dd')}>{moment().day(4).format('dd')}</th>
                        <th className="day-header" key={'trm'+month+''+moment().day(5).format('dd')}>{moment().day(5).format('dd')}</th>
                        <th className="day-header" key={'trm'+month+''+moment().day(6).format('dd')}>{moment().day(6).format('dd')}</th>
                        <th className="day-header" key={'trm'+month+''+moment().day(0).format('dd')}>{moment().day(0).format('dd')}</th>
                    </tr>
                </thead>
                {this.getWeekRows()}
            </table>
            );
    }
}
